// import React, { useState } from "react";
// import { useSubscriptionPlans } from "../../hooks/subscriptions/useSubscriptionPlans";
// import { useMySubscription } from "../../hooks/subscriptions/useMySubscription";
// import { useOrganizationPlan } from "../../hooks/subscriptions/useOrganizationPlan";
// import { selectPlanApi } from "../../apis/subscriptionApi";
// import "./SubscriptionPlans.css";
// import FormDialog from "../../assets/FormDialog";
// import { Eye, CheckCircle } from "lucide-react";

// const SubscriptionPlans = ({ user, isViewOnly, allowPlanSelection }) => {
//   const [search, setSearch] = useState("");
//   const [showAddCard, setShowAddCard] = useState(false);
//   const [showViewCard, setShowViewCard] = useState(null);
//   const [jsonError, setJsonError] = useState("");  const initialPlanState = {
//     name: "",
//     description: "",
//     price_monthly: "",
//     price_yearly: "",
//     max_projects: "",
//     max_client_admins: "",
//     max_project_admins: "",
//     max_surveyors: "",
//     overage_project_price: "",
//     overage_client_admin_price: "",
//     overage_project_admin_price: "",
//     overage_surveyor_price: "",
//     features: "",
//     allows_overage: false,
//     is_active: true,
//   };

//   const [newPlan, setNewPlan] = useState(initialPlanState);
//   // Define it here ── right before you need it
//   const showOverage = newPlan.allows_overage === true;
//      const handleInputChange = (e) => {
//       const { name, value, type, checked } = e.target;
//       console.log(`Changing ${name} →`, type === 'checkbox' ? checked : value);
//       setNewPlan((prev) => {
//         let updated = {
//           ...prev,
//           [name]: type === "checkbox" ? checked : value,
//         };

//         // When user disables overage → clear overage prices
//         if (name === "allows_overage" && checked === false) {
//           updated = {
//             ...updated,
//             overage_project_price: "",
//             overage_client_admin_price: "",
//             overage_project_admin_price: "",
//             overage_surveyor_price: "",
//           };
//         }

//         return updated;
//       });

//       // JSON validation for features (unchanged)
//       if (name === "features") {
//         try {
//           if (value.trim() === "") {
//             setJsonError("");
//           } else {
//             JSON.parse(value);
//             setJsonError("");
//           }
//         } catch {
//           setJsonError("Invalid JSON format for Features.");
//         }
//       }
//     };
//   const {
//   subscription,
//   loading: orgsubLoading,
//   error: orgsubError,
//   refetch: refetchSubscription,
// } = useMySubscription();

//   const isAdmin = user?.role === "admin";



//   const { plans, loading, error, addPlan, fetchPlans } =
//     useSubscriptionPlans(search);

//   const { orgPlan, orgUsage, loading: orgLoading, error: orgError } = useOrganizationPlan(user?.organization);
 

//   const handleAddPlan = async (formValues) => {
//     if (formValues.features?.trim()) {
//       try {
//         JSON.parse(formValues.features);
//       } catch {
//         setJsonError("Features must be valid JSON.");
//         return;
//       }
//     }

//     // Optional: clean payload
//     const payload = { ...formValues };

//     if (!payload.allows_overage) {
//       payload.overage_project_price = null;
//       payload.overage_client_admin_price = null;
//       payload.overage_project_admin_price = null;
//       payload.overage_surveyor_price = null;
//     }

//     try {
//       await addPlan(payload);
//       await fetchPlans(true);
//       setShowAddCard(false);
//       setNewPlan(initialPlanState);
//       setJsonError("");
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleSelectPlan = async (planId) => {
//       if (!allowPlanSelection) return;

//       try {
//         await selectPlanApi(user.organization, planId);
//         await refetchSubscription(); // refresh current plan
//         console.log("Plan selected successfully");
//       } catch (err) {
//         console.error("Failed to select plan:", err);
//       }
//     };
//   const shouldShowOverageFields = (allowsOverage) => allowsOverage === true;
//   const addPlanFields = [
//     { name: "name", label: "Name", type: "text", required: true, gridWidth: 6, group: "Plan Details" },
//     { name: "description", label: "Description", type: "text", gridWidth: 6, group: "Plan Details" },
//     { name: "price_monthly", label: "Price Monthly (₹)", type: "number",required: true, inputProps: { step: "0.01" }, gridWidth: 6, group: "Pricing" },
//     { name: "price_yearly", label: "Price Yearly (₹)", type: "number", required: true,inputProps: { step: "0.01" }, gridWidth: 6, group: "Pricing" },
//     { name: "max_projects", label: "Max Projects", type: "number", required: true,gridWidth: 6, group: "Limits" },
//     { name: "max_client_admins", label: "Client Admins", type: "number", required: true,gridWidth: 6, group: "Limits" },
//     { name: "max_project_admins", label: "Project Admins", type: "number",required: true, gridWidth: 6, group: "Limits" },
//     { name: "max_surveyors", label: "Surveyors", type: "number", required: true,gridWidth: 6, group: "Limits" },
//     {
//       name: "allows_overage",
//       label: "Allows Overage",
//       type: "checkbox",
//       gridWidth: 6,
//       group: "Settings",
//       // Add this to help debug:
//       onChange: (e) => {
//         console.log("Checkbox changed → new value:", e.target.checked);
//         handleInputChange(e);
//       }
//     },
//     {
//       name: "is_active",
//       label: "Active",
//       type: "checkbox",
//       gridWidth: 6,
//       group: "Settings"
//     },
//     // ──────────────────────────────────────────────── Conditional overage group
//   ...(showOverage
//       ? [
//           {
//             name: "overage_project_price",
//             label: "Overage Project Price (₹)",
//             type: "number",
//             inputProps: { step: "0.01" },
//             gridWidth: 6,
//             group: "Overage",
//           },
//           {
//             name: "overage_client_admin_price",
//             label: "Overage Client Admin Price (₹)",
//             type: "number",
//             inputProps: { step: "0.01" },
//             gridWidth: 6,
//             group: "Overage",
//           },
//           {
//             name: "overage_project_admin_price",
//             label: "Overage Project Admin Price (₹)",
//             type: "number",
//             inputProps: { step: "0.01" },
//             gridWidth: 6,
//             group: "Overage",
//           },
//           {
//             name: "overage_surveyor_price",
//             label: "Overage Surveyor Price (₹)",
//             type: "number",
//             inputProps: { step: "0.01" },
//             gridWidth: 6,
//             group: "Overage",
//           },
//         ]
//       : [
//           {
//             name: "overage_notice",
//             label: "",
//             type: "custom",
//             gridWidth: 12,
//             group: "Overage",
//             render: () => (
//               <div style={{ color: "#555", fontSize: "0.95rem", padding: "12px 0" }}>
//                 Overage pricing options appear when "Allows Overage" is enabled.
//               </div>
//             ),
//           },
//         ]),
//   ];

//   const viewPlanFields = addPlanFields.map((field) => ({
//     ...field,
//     type: field.type === "checkbox" || field.type === "textarea" ? "text" : field.type,
//     required: false,
//     inputProps: undefined,
//     placeholder: undefined,
//     error: undefined,
//   }));

//   const getViewInitialValues = (plan) => ({
//     ...plan,
//     allows_overage: plan.allows_overage ? "Yes" : "No",
//     is_active: plan.is_active ? "Yes" : "No",
//     features: plan.features ? JSON.stringify(plan.features, null, 2) : "No features listed",
//   });

//   return (
//     <div className="plans-page">

//       {orgLoading ? (
//         <div className="loading">Loading current plan...</div>
//       ) : orgError ? (
//         <div className="error-card">Error loading organization plan</div>
//       ) : subscription ? (
//         <div className="current-plan-card">
//           <div className="current-plan-header">
//             <h2>Your Current Plan</h2>

//             {(subscription.status === "active" ||
//               subscription.status === "trial") && (
//               <span className="active-badge">
//                 <CheckCircle size={16} /> {subscription.status}
//               </span>
//             )}
//           </div>

//           <div className="plan-info">
//             <h3 className="plan-name">
//               {subscription.plan_details || "Plan"}
//             </h3>

//             <div className="pricing">
//               <div className="price-block">
//                 <span className="period">
//                   Billing: {subscription.billing_cycle}
//                 </span>
//               </div>
//             </div>

//             <div className="subscription-dates">
//               <p><strong>Start:</strong> {subscription.start_date}</p>
//               <p><strong>End:</strong> {subscription.end_date}</p>
//               <p><strong>Next Billing:</strong> {subscription.next_billing_date}</p>
//             </div>

//             {subscription.total_monthly_charge && (
//               <div className="charge-info">
//                 <strong>Total Monthly Charge:</strong> ₹
//                 {subscription.total_monthly_charge}
//               </div>
//             )}
//           </div>
//         </div>
//       ) : (
//         <div className="no-plan-card">
//           <h3>No Active Plan</h3>
//           <p>Choose a plan below to get started.</p>
//         </div>
//       )}

//       {/* Header + Add Button */}
//       <div className="plans-header">
//         <div>
//           <h1 className="section-title">Available Plans</h1>
//           <p className="section-subtitle">Choose the plan that best fits your organization's needs</p>
//         </div>
//         {isAdmin && (
//           <button className="add-plan-btn" onClick={() => setShowAddCard(true)}>
//             + Create New Plan
//           </button>
//         )}
//       </div>

//       {/* Search */}
//       <div className="search-container">
//         <input
//           type="text"
//           placeholder="Search plans by name or features..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           className="search-input"
//         />
//       </div>

//       {/* Add Plan Dialog */}
//       {isAdmin && (
//         <FormDialog
//           open={showAddCard}
//           onClose={() => {
//             setShowAddCard(false);
//             setNewPlan({ ...initialPlanState });
//             setJsonError("");
//           }}
//           title="Create New Subscription Plan"
//           fields={addPlanFields}
//           initialValues={newPlan}
//           onSubmit={handleAddPlan}
//           submitLabel="Create Plan"
//           cancelLabel="Cancel"
//         />
//       )}

//       {/* Plans Grid */}
//       {loading ? (
//         <div className="loading-grid">Loading plans...</div>
//       ) : error ? (
//         <div className="error-message">{error}</div>
//       ) : plans.length === 0 ? (
//         <div className="empty-state">
//           <h3>No plans available</h3>
//           <p>{search ? "Try adjusting your search" : "No subscription plans found"}</p>
//         </div>
//       ) : (
//         <div className="plans-grid">
//           {plans.map((plan) => (
//             <div
//               key={plan.id}
//               className={`plan-card ${plan.is_active ? "" : "inactive"} ${orgPlan?.id === plan.id ? "current-plan" : ""
//                 }`}
//             >
//               {orgPlan?.id === plan.id && (
//                 <div className="current-tag">Current Plan</div>
//               )}

//               <h3 className="plan-name">{plan.name}</h3>

//               <div className="plan-price">
//                 ₹{plan.price_monthly?.toLocaleString() || "0"}
//                 <span className="period"> / month</span>
//               </div>

//               {plan.price_yearly && (
//                 <div className="plan-price-yearly">
//                   ₹{plan.price_yearly?.toLocaleString()} / year
//                 </div>
//               )}

//               <p className="plan-description">{plan.description || "No description"}</p>

//               <ul className="plan-features">
//                 <li>Max Projects: <strong>{plan.max_projects}</strong></li>
//                 <li>Client Admins: <strong>{plan.max_client_admins}</strong></li>
//                 <li>Project Admins: <strong>{plan.max_project_admins}</strong></li>
//                 <li>Surveyors: <strong>{plan.max_surveyors}</strong></li>
//                 {plan.allows_overage && <li>Allows overage usage</li>}
//               </ul>

//               {allowPlanSelection && (
//                 <button
//                   className={`select-btn ${orgPlan?.id === plan.id ? "selected" : ""}`}
//                   onClick={() => handleSelectPlan(plan.id)}
//                   disabled={orgPlan?.id === plan.id || !plan.is_active}
//                 >
//                   {orgPlan?.id === plan.id
//                     ? "Current Plan"
//                     : plan.is_active
//                       ? "Select Plan"
//                       : "Inactive"}
//                 </button>
//               )}

//               <button
//                 className="view-details-btn"
//                 onClick={() => setShowViewCard(plan.id)}
//               >
//                 <Eye size={16} /> View Details
//               </button>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* View Plan Dialog */}
//       {showViewCard && (
//         <FormDialog
//           open={!!showViewCard}
//           onClose={() => setShowViewCard(null)}
//           title="Plan Details"
//           fields={viewPlanFields}
//           initialValues={getViewInitialValues(plans.find((p) => p.id === showViewCard) || {})}
//           viewMode={true}
//           submitLabel="Close"
//           cancelLabel="Close"
//         />
//       )}
//     </div>
//   );
// };

// export default SubscriptionPlans;

import React, { useState } from "react";
import { useSubscriptionPlans } from "../../hooks/subscriptions/useSubscriptionPlans";
import { useMySubscription } from "../../hooks/subscriptions/useMySubscription";
import { useOrganizationPlan } from "../../hooks/subscriptions/useOrganizationPlan";
import { selectPlanApi } from "../../apis/subscriptionApi";
import "./SubscriptionPlans.css";
import FormDialog from "../../assets/FormDialog";
import { Eye, CheckCircle } from "lucide-react";

const SubscriptionPlans = ({ user, isViewOnly, allowPlanSelection }) => {
  const [search, setSearch] = useState("");
  const [showAddCard, setShowAddCard] = useState(false);
  const [showViewCard, setShowViewCard] = useState(null);
  const [jsonError, setJsonError] = useState("");

  const initialPlanState = {
    name: "",
    description: "",
    price_monthly: "",
    price_yearly: "",
    max_projects: "",
    max_client_admins: "",
    max_project_admins: "",
    max_surveyors: "",
    overage_project_price: "",
    overage_client_admin_price: "",
    overage_project_admin_price: "",
    overage_surveyor_price: "",
    features: "",
    allows_overage: false,
    is_active: true,
  };

  const [newPlan, setNewPlan] = useState(initialPlanState);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setNewPlan((prev) => {
      let updated = {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };

      // When user disables overage → clear overage prices
      if (name === "allows_overage" && checked === false) {
        updated = {
          ...updated,
          overage_project_price: "",
          overage_client_admin_price: "",
          overage_project_admin_price: "",
          overage_surveyor_price: "",
        };
      }

      return updated;
    });

    // JSON validation for features
    if (name === "features") {
      try {
        if (value.trim() === "") {
          setJsonError("");
        } else {
          JSON.parse(value);
          setJsonError("");
        }
      } catch {
        setJsonError("Invalid JSON format for Features.");
      }
    }
  };

  const {
    subscription,
    loading: orgsubLoading,
    error: orgsubError,
    refetch: refetchSubscription,
  } = useMySubscription();

  const isAdmin = user?.role === "admin";

  const { plans, loading, error, addPlan, fetchPlans } = useSubscriptionPlans(search);

  const { orgPlan, orgUsage, loading: orgLoading, error: orgError } =
    useOrganizationPlan(user?.organization);

  const handleAddPlan = async (formValues) => {
    if (formValues.features?.trim()) {
      try {
        JSON.parse(formValues.features);
      } catch {
        setJsonError("Features must be valid JSON.");
        return;
      }
    }

    const payload = { ...formValues };

    if (!payload.allows_overage) {
      payload.overage_project_price = null;
      payload.overage_client_admin_price = null;
      payload.overage_project_admin_price = null;
      payload.overage_surveyor_price = null;
    }

    try {
      await addPlan(payload);
      await fetchPlans(true);
      setShowAddCard(false);
      setNewPlan(initialPlanState);
      setJsonError("");
    } catch (err) {
      console.error(err);
    }
  };

  const handleSelectPlan = async (planId) => {
    if (!allowPlanSelection) return;

    try {
      await selectPlanApi(user.organization, planId);
      await refetchSubscription();
      console.log("Plan selected successfully");
    } catch (err) {
      console.error("Failed to select plan:", err);
    }
  };

  const addPlanFields = [
    { name: "name", label: "Name", type: "text", required: true, gridWidth: 6, group: "Plan Details" },
    { name: "description", label: "Description", type: "text", gridWidth: 6, group: "Plan Details" },
    {
      name: "price_monthly",
      label: "Price Monthly (₹)",
      type: "number",
      required: true,
      inputProps: { step: "0.01" },
      gridWidth: 6,
      group: "Pricing",
    },
    {
      name: "price_yearly",
      label: "Price Yearly (₹)",
      type: "number",
      required: true,
      inputProps: { step: "0.01" },
      gridWidth: 6,
      group: "Pricing",
    },
    { name: "max_projects", label: "Max Projects", type: "number", required: true, gridWidth: 6, group: "Limits" },
    {
      name: "max_client_admins",
      label: "Client Admins",
      type: "number",
      required: true,
      gridWidth: 6,
      group: "Limits",
    },
    {
      name: "max_project_admins",
      label: "Project Admins",
      type: "number",
      required: true,
      gridWidth: 6,
      group: "Limits",
    },
    { name: "max_surveyors", label: "Surveyors", type: "number", required: true, gridWidth: 6, group: "Limits" },
    {
      name: "allows_overage",
      label: "Allows Overage",
      type: "checkbox",
      gridWidth: 6,
      group: "Settings",
    },
    {
      name: "is_active",
      label: "Active",
      type: "checkbox",
      gridWidth: 6,
      group: "Settings",
    },
    // Overage fields — only included in the array when allows_overage is true
    ...(newPlan.allows_overage
      ? [
          {
            name: "overage_project_price",
            label: "Overage Project Price (₹)",
            type: "number",
            inputProps: { step: "0.01" },
            gridWidth: 6,
            group: "Overage",
          },
          {
            name: "overage_client_admin_price",
            label: "Overage Client Admin Price (₹)",
            type: "number",
            inputProps: { step: "0.01" },
            gridWidth: 6,
            group: "Overage",
          },
          {
            name: "overage_project_admin_price",
            label: "Overage Project Admin Price (₹)",
            type: "number",
            inputProps: { step: "0.01" },
            gridWidth: 6,
            group: "Overage",
          },
          {
            name: "overage_surveyor_price",
            label: "Overage Surveyor Price (₹)",
            type: "number",
            inputProps: { step: "0.01" },
            gridWidth: 6,
            group: "Overage",
          },
        ]
      : []),
  ];

  const viewPlanFields = addPlanFields.map((field) => ({
    ...field,
    type: field.type === "checkbox" || field.type === "textarea" ? "text" : field.type,
    required: false,
    inputProps: undefined,
    placeholder: undefined,
    error: undefined,
  }));

  const getViewInitialValues = (plan) => ({
    ...plan,
    allows_overage: plan.allows_overage ? "Yes" : "No",
    is_active: plan.is_active ? "Yes" : "No",
    features: plan.features ? JSON.stringify(plan.features, null, 2) : "No features listed",
  });

  return (
    <div className="plans-page">
      {orgLoading ? (
        <div className="loading">Loading current plan...</div>
      ) : orgError ? (
        <div className="error-card">Error loading organization plan</div>
      ) : subscription ? (
        <div className="current-plan-card">
          <div className="current-plan-header">
            <h2>Your Current Plan</h2>

            {(subscription.status === "active" || subscription.status === "trial") && (
              <span className="active-badge">
                <CheckCircle size={16} /> {subscription.status}
              </span>
            )}
          </div>

          <div className="plan-info">
            <h3 className="plan-name">{subscription.plan_details || "Plan"}</h3>

            <div className="pricing">
              <div className="price-block">
                <span className="period">Billing: {subscription.billing_cycle}</span>
              </div>
            </div>

            <div className="subscription-dates">
              <p>
                <strong>Start:</strong> {subscription.start_date}
              </p>
              <p>
                <strong>End:</strong> {subscription.end_date}
              </p>
              <p>
                <strong>Next Billing:</strong> {subscription.next_billing_date}
              </p>
            </div>

            {subscription.total_monthly_charge && (
              <div className="charge-info">
                <strong>Total Monthly Charge:</strong> ₹{subscription.total_monthly_charge}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="no-plan-card">
          <h3>No Active Plan</h3>
          <p>Choose a plan below to get started.</p>
        </div>
      )}

      {/* Header + Add Button */}
      <div className="plans-header">
        <div>
          <h1 className="section-title">Available Plans</h1>
          <p className="section-subtitle">Choose the plan that best fits your organization's needs</p>
        </div>
        {isAdmin && (
          <button className="add-plan-btn" onClick={() => setShowAddCard(true)}>
            + Create New Plan
          </button>
        )}
      </div>

      {/* Search */}
      <div className="search-container">
        <input
          type="text"
          placeholder="Search plans by name or features..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
      </div>

      {/* Add Plan Dialog */}
      {isAdmin && (
        <FormDialog
          open={showAddCard}
          onClose={() => {
            setShowAddCard(false);
            setNewPlan({ ...initialPlanState });
            setJsonError("");
          }}
          title="Create New Subscription Plan"
          fields={addPlanFields}
          initialValues={newPlan}
          onChange={handleInputChange}
          onSubmit={handleAddPlan}
          submitLabel="Create Plan"
          cancelLabel="Cancel"
        />
      )}

      {/* Plans Grid */}
      {loading ? (
        <div className="loading-grid">Loading plans...</div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : plans.length === 0 ? (
        <div className="empty-state">
          <h3>No plans available</h3>
          <p>{search ? "Try adjusting your search" : "No subscription plans found"}</p>
        </div>
      ) : (
        <div className="plans-grid">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`plan-card ${plan.is_active ? "" : "inactive"} ${
                orgPlan?.id === plan.id ? "current-plan" : ""
              }`}
            >
              {orgPlan?.id === plan.id && <div className="current-tag">Current Plan</div>}

              <h3 className="plan-name">{plan.name}</h3>

              <div className="plan-price">
                ₹{plan.price_monthly?.toLocaleString() || "0"}
                <span className="period"> / month</span>
              </div>

              {plan.price_yearly && (
                <div className="plan-price-yearly">₹{plan.price_yearly?.toLocaleString()} / year</div>
              )}

              <p className="plan-description">{plan.description || "No description"}</p>

              <ul className="plan-features">
                <li>
                  Max Projects: <strong>{plan.max_projects}</strong>
                </li>
                <li>
                  Client Admins: <strong>{plan.max_client_admins}</strong>
                </li>
                <li>
                  Project Admins: <strong>{plan.max_project_admins}</strong>
                </li>
                <li>
                  Surveyors: <strong>{plan.max_surveyors}</strong>
                </li>
                {plan.allows_overage && <li>Allows overage usage</li>}
              </ul>

              {allowPlanSelection && (
                <button
                  className={`select-btn ${orgPlan?.id === plan.id ? "selected" : ""}`}
                  onClick={() => handleSelectPlan(plan.id)}
                  disabled={orgPlan?.id === plan.id || !plan.is_active}
                >
                  {orgPlan?.id === plan.id
                    ? "Current Plan"
                    : plan.is_active
                    ? "Select Plan"
                    : "Inactive"}
                </button>
              )}

              <button className="view-details-btn" onClick={() => setShowViewCard(plan.id)}>
                <Eye size={16} /> View Details
              </button>
            </div>
          ))}
        </div>
      )}

      {/* View Plan Dialog */}
      {showViewCard && (
        <FormDialog
          open={!!showViewCard}
          onClose={() => setShowViewCard(null)}
          title="Plan Details"
          fields={viewPlanFields}
          initialValues={getViewInitialValues(plans.find((p) => p.id === showViewCard) || {})}
          viewMode={true}
          submitLabel="Close"
          cancelLabel="Close"
        />
      )}
    </div>
  );
};

export default SubscriptionPlans;